import React from 'react';
import { Box, Image, Typography, BRAND_NAME, BRAND_LOGO_ALT } from '../../../design-system';
import { colors } from '../../../design-system/colors';
import { handleLogoClick } from './handlers/footerHandlers';
import logo from '../../../../assets/brand/logo_site.svg';

const FooterLogo: React.FC = () => {
  return (
    <Box
      component="button"
      onClick={handleLogoClick}
      sx={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        '&:hover': {
          opacity: 0.8,
        },
        '&:focus-visible': {
          outline: `2px solid ${colors.primary[500]}`,
          outlineOffset: '2px',
          borderRadius: '4px',
        },
      }}
      aria-label="Go to top of page"
    >
      <Image
        src={logo}
        alt={BRAND_LOGO_ALT}
        containerProps={{
          sx: {
            height: { xs: '32px', md: '40px' },
            width: 'auto',
          },
        }}
        imageStyle={{
          height: '100%',
          width: 'auto',
        }}
      />
      <Typography
        variant="headingMedium"
        sx={{
          color: colors.neutral.white,
          fontSize: '18px',
          fontWeight: 400,
          lineHeight: '27px',
        }}
      >
        {BRAND_NAME}
      </Typography>
    </Box>
  );
};

export default FooterLogo;
